import { Box, Button, TableCell, TableRow, styled } from "@mui/material";

export const StyledBox = styled(Box)({
  marginTop: 24,
  padding: 24,
  borderRadius: 8,
  boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.2)",
  backgroundColor: "#ffffff",
});

export const StyledTableCell = styled(TableCell)({
  fontWeight: "bold",
  color: "rgba(0, 0, 0, 0.6)",
  backgroundColor: "rgba(240, 240, 240, 1)",
});

export const StyledTableCellRow = styled(TableCell)(({ theme: { palette } }) => ({
  borderBottomColor: palette.grey[400],
}));

export const StyledButton = styled(Button)({
  textTransform: "none",
});

export const StyledTableRow = styled(TableRow)({
  backgroundColor: "#ffffff",
});
